<template>
  <div class="flex flex-col lg:flex-row w-full h-full mx-auto py-4 lg:p-6">
    <div class="bg-white shadow-lg rounded-lg w-12/12 lg:w-2/6 mx-4 py-4 overflow-hidden mb-4 lg:mb-0">
      <div class="h-full overflow-auto px-4">
        <div class="flex items-center gap-1 justify-end pb-4 sticky top-0 bg-white relative z-10">
          <h1 class="flex items-center gap-1 font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider">
            Invitaciones
            <span class="rounded-full px-4 py-1 bg-gray-200">
              {{ filteredUserList.length }}
            </span>
          </h1>
          <div class="flex-1"></div>
          <button
            class="border p-1 rounded border-gray-700"
            @click="changeFormOrder"
            aria-label="Ordenar usuarios ascentente o descendente"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"/>
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>

          <btn-action
            class="px-3 py-1 bg-transparent font-semibold hover:text-white border rounded"
            @click="newDataModal()"
            :colorT="color_terciario"
          >
            Invitar
          </btn-action>
        </div>

        <input
          type="text"
          v-model="search"
          placeholder="Búsqueda de invitados"
          class="w-full appearance-none border rounded py-2 px-3 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white"
        />
        
        <div class="w-full my-1">
          <div class="w-full relative">
            <select
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              name="status"
              id="status"
              v-model="categoryFilter"
            >
              <option selected value="-1">Todos</option>
              <option v-for="category in userCategories" :key="category.id" :value="category.id">
                {{ category.name_category }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
      
        <!-- <div class="w-full flex pt-4 pb-2">
          <button
            v-on:click="statusFilterUser = 'all', filteredUserList"
            class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-secondary-color-dark hover:border-transparent rounded"
            v-bind:class="[statusFilterUser === 'all' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
          >Todos</button>
          <button
            v-on:click="statusFilterUser = 'active', filteredUserList"
            class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
            v-bind:class="[statusFilterUser === 'active' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
          >Activos</button>
          <button
            v-on:click="statusFilterUser = 'inactive', filteredUserList"
            class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-r border-b border-secondary-color-dark hover:border-transparent rounded"
            v-bind:class="[statusFilterUser === 'inactive' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
          >Inactivos</button>
        </div> -->

      
        <div-selected-styled
          v-for="currentUser in filteredUserList"
          v-on:click="getUser(currentUser)"
          :key="currentUser.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{ 'bg-selected': currentUser.id === user.id }"
          :colorT="color_terciario"
        >
          <img
            :src="currentUser.profile_image"
            @error="loadDefaultImg"
            class="object-cover h-12 w-12 rounded-full"
            v-bind:class="[
              currentUser.inactive
                ? 'border-solid border-2 border-danger-color'
                : 'border-solid border-2 border-primary-color'
            ]"
          />
          <div class="flex flex-col ml-2">
            <span
              :class="[
                currentUser.id === user.id ? 'text-gray-100' : 'text-gray-900'
              ]"
              class="group-hover:text-gray-900"
              >{{ currentUser.email }}</span
            >
            <span
              :class="[
                currentUser.id === user.id ? 'text-gray-300' : 'text-gray-700'
              ]"
              class="text-sm group-hover:text-gray-700"
              >{{ currentUser.name_category }}</span
            >
          </div>
        </div-selected-styled>
      </div>
    </div>
    
    <div class="bg-white shadow-lg rounded-lg w-12/12 lg:w-4/6 mx-4 pt-8 pb-6 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center">
          <div class="flex-1 text-right">
            <btn-action
              @click="showingSendEmailConfirm = true"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
            >
              Enviar Email
            </btn-action>
            <btn-action
              v-on:click="updateDataModal(user)"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
            >
              Editar
            </btn-action>
            <button
              @click="showingConfirm = true"
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-danger-color hover:border-transparent rounded"
            >
              Eliminar
            </button>
          </div>
        </div>
        <div class="w-full flex flex-wrap items-center" v-if="user">
          <!-- <div class="w-1/3 flex items-center justify-center">
            <img
              :src="user.profile_image"
              class="object-cover h-64 w-64 rounded-full"
              v-bind:class="[user.inactive ? 'border-solid border-4 border-danger-color' : 'border-solid border-4 border-primary-color']"
            />
          </div> -->
          <div class="w-full pt-8 text-left px-10">
            <span class="font-bold text-gray-900 text-lg"
              >Información Personal</span
            >
            <div class="w-full">
              <div class="flex items-center pt-2 text-sm">
                <span class="font-bold text-gray-900">Nombre:</span>
                <span class="ml-2 text-gray-700">{{ user.email }}</span>
              </div>
              <div class="flex items-center pt-2 text-sm">
                <span class="font-bold text-gray-900">Perfil:</span>
                <span class="ml-2 text-gray-700">{{ user.name_category }}</span>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>

    <guest-user-modal
      :newGuestUser="newGuestUser"
      :showing="showGuestUserModal"
      @updateGuestUser="updateGuestUser"
      @updateAllGuestUser="updateAllGuestUser"
      @close="showGuestUserModal = false"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></guest-user-modal>

    <alert-dialog :showing="showingSendEmailConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea enviar nuevamente esta invitación?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="sendEmail()"
        >
          Enviar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSendEmailConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSendEmailSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Correo de invitación enviado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSendEmailSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea eliminar esta invitación?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateActivity()"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import guestUserModal from "./GuestUserModal";
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";
import moment from "moment";
import axios from "axios";
import XLSX from "xlsx";

import { styled } from "@egoist/vue-emotion";

const BtnAction = styled("button")`
  color: ${props => props.colorT};
  border-color: ${props => props.colorT};
  &.bg-selected {
    background-color: ${props => props.colorT};
    color: #fff;
  }
  &:hover {
    background-color: ${props => props.colorT};
  }
`;

const DivSelectedStyled = styled("div")`
  &.bg-selected {
    background-color: ${props => props.colorT};
  }
  &:hover {
    background-color: #d1d5db;
  }
`;

export default {
  name: "userList",
  data() {
    return {
      category: window.atob(localStorage.getItem("category")),
      showChatModal: false,
      showingConfirm: false,
      showingSendEmailConfirm: false,
      showingSendEmailSuccess: false,
      showingSuccessDelete: false,
      showGuestUserModal: false,
      userList: [],
      user: null,
      newGuestUser: false,
      search: "",
      statusFilterUser: "all",
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      categoryFilter: "-1",
      userCategories: [],
      formOrder: "upward",
      color_principal: "",
      color_secundario: "",
      color_terciario: ""
    };
  },
  components: {
    guestUserModal,
    AlertDialog,
    BtnAction,
    DivSelectedStyled
  },
  created() {
    let that = this;
  },
  mounted() {
    EventBus.$emit("updateNotification", {});
    this.getGuestUserList();
    this.fetchUserCategories();
  },
  methods: {
    closeChatsModal() {
      this.showChatModal = false;
    },
    getGuestUserList: function () {
      this.$root.$emit("showLoading");
      axios
        .get("apidev/users/guest/list", this.config)
        .then(response => {
          this.userList = response.data;
          this.userList.forEach(data => {
            data.profile_image =
              "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
          });

          if (this.userList.length > 0) {
            this.user = this.userList[0];
          }
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          // removed console log
          this.catchError(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    getUser: function (user) {
      this.user = user;
    },

    updateDataModal: function (user) {
      this.showGuestUserModal = true;
      this.newGuestUser = false;
      EventBus.$emit("editModal", user);
    },

    newDataModal: function () {
      this.showGuestUserModal = true;
      this.newGuestUser = true;
    },

    updateGuestUser: function (select_user) {
      this.userList.forEach(user => {
        if (user.id == select_user.id) {
          let updateUser = Object.assign({}, select_user);
          user.email = updateUser.email;
          user.name_category = updateUser.name_category;
        }
      });
    },
    updateAllGuestUser: function () {
      this.getGuestUserList();
    },

    sendEmail: function () {
      this.$root.$emit("showLoading");

      this.axios
        .post(
          "apidev/users/guest/send",
          {
            email: this.user.email
          },
          this.config
        )
        .then(() => {
          this.showingSendEmailConfirm = false;
          this.showingSendEmailSuccess = true;
          this.$root.$emit("hideLoading");

          //guarda bitácora
          let name = localStorage.getItem("name");
          //// removed console log

          this.axios
            .post(
              "/apidev/bitacoras/save/",
              {
                module: "Invitaciones",
                action: "Invitación re-enviada",
                observation:
                  name +
                  " re-envió la invitación a '" +
                  this.user.email +
                  "' con el rol de " +
                  this.user.name_category,
                email: localStorage.getItem("email"),
                user_id: localStorage.getItem("user_id")
              },
              this.config
            )
            .then(response => {
              //// removed console log
            })
            .catch(error => {
              // removed console log
            });
          //FIN guarda bitácora
        })
        .catch(error => {
          this.catchError(error);
        });
    },

    updateActivity: function (status) {
      this.$root.$emit("showLoading");
      this.axios
        .delete("apidev/users/guest/inactive/" + this.user.id, this.config)
        .then(response => {
          this.showingConfirm = false;
          this.showingSuccessDelete = true;
          //guarda bitácora
          let name = localStorage.getItem("name");

          //// removed console log
          this.axios
            .post(
              "/apidev/bitacoras/save/",
              {
                module: "Invitaciones",
                action: "Invitación eliminada",
                observation:
                  name + " eliminó la invitación a '" + this.user.email + "'",
                email: localStorage.getItem("email"),
                user_id: localStorage.getItem("user_id")
              },
              this.config
            )
            .then(response => {
              //// removed console log
            })
            .catch(error => {
              // removed console log
            });
          //FIN guarda bitácora

          this.getGuestUserList();
        })
        .catch(error => {
          this.catchError(error);
        });
    },
    fetchUserCategories() {
      this.$root.$emit("showLoading");
      this.axios
        .get("apidev/users/categories", this.config)
        .then(response => {
          this.userCategories = response.data.categories;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          this.catchError(error);
        });
    },
    loadDefaultImg(event) {
      event.target.src =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then(response => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    }
  },
  computed: {
    filteredUserList: function () {
      return this.userList
        .filter(user => {
          let full_name = user.email;
          switch (this.statusFilterUser) {
            case "all":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            case "active":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                !user.inactive &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            case "inactive":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                user.inactive &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            if (a.email.toLowerCase() < b.email.toLowerCase()) {
              return -1;
            }
            if (a.email.toLowerCase() > b.email.toLowerCase()) {
              return 1;
            }
            return 0;
          } else {
            if (a.email.toLowerCase() > b.email.toLowerCase()) {
              return -1;
            }
            if (a.email.toLowerCase() < b.email.toLowerCase()) {
              return 1;
            }
            return 0;
          }
        });
    }
  },
  beforeMount() {
    this.fetchConfiguration();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
